<div>
  <app-nav></app-nav>
  <ngb-alert [type]="alert?.type" *ngIf="alert?.showAlert" (close)="alert.showAlert = false" [dismissible]="true">
    {{ alert.message }}
  </ngb-alert>
  <router-outlet></router-outlet>
</div>
